import script from "./ProductRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductRegister.vue?vue&type=script&setup=true&lang=js"

import "./ProductRegister.vue?vue&type=style&index=0&id=a48d0452&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a48d0452"]])

export default __exports__